import React from 'react'

import { Placeholder } from '@app/lib/inputs/RichEditor/extensions/Placeholder/Placeholder'
import {
  ElementRenderProps,
  PlaceholderElement,
  StructuredTextElement,
  ListElementType,
  ListItemElementType,
  PlaceholderType,
  TextElementType
} from '@app/lib/inputs/RichEditor/types'

export const Element = ({
  attributes,
  children,
  element
}: ElementRenderProps<StructuredTextElement | PlaceholderElement>) => {
  switch (element.type) {
    case ListElementType.NumberedList:
      return <ol {...attributes}>{children}</ol>

    case ListElementType.BulletedList:
      return <ul {...attributes}>{children}</ul>

    case ListItemElementType.ListItem:
      return <li {...attributes}>{children}</li>

    case TextElementType.HeadingOne:
      return <h1 {...attributes}>{children}</h1>

    case TextElementType.HeadingTwo:
      return <h2 {...attributes}>{children}</h2>

    case PlaceholderType.Placeholder:
      return (
        <Placeholder attributes={attributes} element={element}>
          {children}
        </Placeholder>
      )

    default:
      return <p {...attributes}>{children}</p>
  }
}
